/* global SENTRY_PUBLIC_DSN, SENTRY_USER, SENTRY_SPLIT_TAGS */
import * as Sentry from '@sentry/browser'

export default function () {
  // NOTE: These are lists compiled by the community and suggested by sentry in
  // https://docs.sentry.io/platforms/javascript/#decluttering-sentry
  const ignoreErrors = [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    'Non-Error exception captured',
    'Non-Error promise rejection captured'
  ]

  const denyUrls = [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
  ]

  const allowUrls = [
    /vinterior\.co/,
    /vinterior-app\.herokuapp\.com/,
    /vinterior-beta\.herokuapp\.com/,
    /cdn\.jsdelivr\.net/
  ]

  const sentryOptions = {
    dsn: SENTRY_PUBLIC_DSN,
    environment: process.env.NODE_ENV,
    ignoreErrors,
    denyUrls,
    allowUrls: (process.env.NODE_ENV === 'production') ? allowUrls : []
  }

  Sentry.init(sentryOptions)
  Sentry.setUser(SENTRY_USER)
  Sentry.setTags(SENTRY_SPLIT_TAGS)

  window.Sentry = Sentry
}
